import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, } from "react";
import { Icon } from "../../icon";
import { Button } from "../../button";
// components
import { StyledWrapper } from "../common/Wrapper.styles";
import { ErrorLabel } from "../common/Error.styles";
import { Label } from "../common/Label.styles";
import { Input, InputWrapper } from "./Input.styles";
// utils
import { makeDataTestIdGetter } from "../../utils";
export const FormField = ({ onChange, onMouseDown, onBlur, type = "text", errorMessage, errors, name, values, label, icon, placeholder, readOnly, reset, required, disabled, defaultValue, onIconClick, iconAlignment = "left", textAlignment = "left", inputValue, min, max, pattern, title, previewId, dataTestIdPrefix, }) => {
    var _a, _b;
    const [focused, setFocused] = useState(false);
    const [selected, setSelected] = useState(false);
    const hasMinMax = [
        "date",
        "number",
        "time",
        "week",
        "month",
        "datetime-local",
    ];
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    return (_jsxs(StyledWrapper, Object.assign({ type: type, values: values, name: name }, { children: [icon && iconAlignment === "left" && _jsx(Icon, { withHitSpace: true, symbol: icon }), label && (_jsxs(Label, Object.assign({ hasError: Boolean(errors === null || errors === void 0 ? void 0 : errors[name]), htmlFor: name }, { children: [label, label && required && "*"] }))), _jsxs(InputWrapper, Object.assign({ withIcon: icon && iconAlignment === "left", hasReset: !!reset }, { children: [_jsx(Input, Object.assign({ "data-preview-id": previewId, id: name, readOnly: readOnly, placeholder: placeholder, textAlignment: textAlignment, focused: focused, selected: selected, pattern: pattern, title: title }, (hasMinMax.includes(type)
                        ? { min, max }
                        : { minLength: min, maxLength: max }), { onFocus: () => setSelected(true), onChange: (e) => {
                            if (onChange) {
                                onChange(e);
                            }
                        }, onMouseDown: (e) => {
                            setFocused(false);
                            setSelected(false);
                            if (typeof onMouseDown === "function") {
                                onMouseDown(e);
                            }
                        }, onKeyUp: (e) => {
                            if (e && e.key === "Tab")
                                setFocused(true);
                            setSelected(true);
                        }, onBlur: (e) => {
                            setFocused(false);
                            setSelected(false);
                            if (onBlur)
                                onBlur(e);
                        }, errors: errors, name: name, type: type, value: defaultValue || inputValue || (values === null || values === void 0 ? void 0 : values[name]), disabled: disabled, "data-testid": getDataTestId("formfield-input") })), (((_a = values === null || values === void 0 ? void 0 : values[name]) === null || _a === void 0 ? void 0 : _a.length) === 0 || !(values === null || values === void 0 ? void 0 : values[name])) &&
                        !inputValue &&
                        iconAlignment === "right" &&
                        icon && (_jsx(Button, { onClick: onIconClick, disabled: disabled, stylingType: "flat", isIcon: true, symbol: icon })), (((_b = values === null || values === void 0 ? void 0 : values[name]) === null || _b === void 0 ? void 0 : _b.length) > 0 || inputValue) && reset && (_jsx(Button, { onClick: reset, disabled: disabled, stylingType: "flat", isIcon: true, symbol: "Close" })), type === "date" && !(values === null || values === void 0 ? void 0 : values[name]) && !inputValue && (_jsx(Icon, { symbol: "Calendar", withHitSpace: true }))] })), (errors === null || errors === void 0 ? void 0 : errors[name]) && (_jsx(ErrorLabel
            // we can use dangerouslySetInnerHTML here because we control the error messages
            , { 
                // we can use dangerouslySetInnerHTML here because we control the error messages
                dangerouslySetInnerHTML: { __html: errorMessage || errors[name] } }))] })));
};
